import React from "react";

import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";
import {
  generateCalendarDayHeader,
  NumericalDayOfWeek,
} from "@whoosh/utilities/src/calendars";

export const DaysOfWeekHeader = ({
  clubWeekStartsOn,
}: {
  clubWeekStartsOn: NumericalDayOfWeek;
}) => {
  const dayNames = generateCalendarDayHeader(clubWeekStartsOn);
  return (
    <HStack
      justifyContent="space-between"
      alignItems={"center"}
      testID={`days-of-the-week-header`}
    >
      {dayNames.map((name) => {
        return (
          <Box width={40} key={name} paddingVertical={1}>
            <Text
              color="text-secondary"
              variant="mainMicro"
              textAlign={"center"}
            >
              {name}
            </Text>
          </Box>
        );
      })}
    </HStack>
  );
};
